<div class="sub-navbar" [class.scrolled]="scrolled()">
    <div class="sub-navbar__left">
        @if (parent()) {
            <ntv-breadcrumbs [items]="breadcrumbItems" variant="minimal"></ntv-breadcrumbs>
        } @else {
            <h2 class="sub-navbar__title">{{ title() }}</h2>
        }
    </div>

    <div class="sub-navbar__right">
        @if (subNavbarService.content()) {
            <ng-container [ngTemplateOutlet]="subNavbarService.content()!"></ng-container>
        } @else if (!subNavbarService.hideDate()) {
            <span class="sub-navbar__date">{{ today | date: 'EEEE, MMMM dd, yyyy' }}</span>
        }
    </div>
</div>
